import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { DEFAULT_COUNTRY } from "@constants";
import { PrefillStore, PrefillStoreProps, StorageKey, UserResidenceStatus } from "@ctypes";

export const DEFAULT_PREFILL_PROPS: PrefillStoreProps = {
  country: DEFAULT_COUNTRY,
  residenceStatus: UserResidenceStatus.Citizen,
};

export const usePrefillStore = create<PrefillStore>()(
  persist(
    (set) => ({
      prefillProps: DEFAULT_PREFILL_PROPS,
      setPrefillProps: (prefillProps: PrefillStoreProps) => set(() => ({ prefillProps })),
    }),
    {
      name: StorageKey.PrefillProps,
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ prefillProps: state.prefillProps }),
    },
  ),
);
